
/*
 * @Descripttion: 卫星系列查询
 * @version:
 * @Author: jerry
 * @Date: 2022-10-09
 * @LastEditors: jerry
 * @LastEditTime: 2022-10-09
 */
import * as config from "./config";
// 父级卫星系列查询
export const satelliteClass = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/satellite/list/parent';
// 卫星等级
export const satelliteLevel = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/static/data/level';
// 卫星系列子卫星
export const satelliteSon = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/satellite/list/';
// 卫星产品查询
export const searchGoodsList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/v2/api/goods/page';
// 所有卫星数据
export const satelliteAll = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/satellite/list/all';

// 地图搜索触发
export const searchMapList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/coordinate/page';



